module.exports = __webpack_public_path__ + "static/img/智能养老.81a0c0aa.png";